import React from 'react'

import { SxProps } from '@mui/material'

import { useTranslation } from 'language/translator'
import { useQuery } from 'utils/hooks'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'

import SectionHeader from 'components_new/molecules/SectionHeader'
import SelectSearch from 'components_new/molecules/SelectSearch'

import { getSelectedOptions } from 'utils/functions'
import { useQueryParamState } from 'utils/queryHandler'

import { ISelectEntity } from 'types/GlobalEntities'

import Loading from './loading'

interface Props {
  entity: ISelectEntity | null
  sx?: SxProps
}

const EntityHeader = React.memo((props: Props) => {
  const { entity, sx } = props
  const { t, lang } = useTranslation()

  const { query } = useQuery()
  const edit = Boolean(query['edit'])

  const sliceOptions = (entity?.slices.available || []).map((slice) => ({
    id: slice.id,
    title: slice.name
  }))

  const [slices, setSlices] = useQueryParamState(
    'slices',
    [],
    sliceOptions.map((opt) => opt.id)
  )

  const selectedSlices = getSelectedOptions(slices, sliceOptions)

  if (!entity) {
    return <Loading />
  }

  return (
    <SectionHeader
      actions={
        <SelectSearch
          color="primary"
          closeOnSelect={true}
          disabled={edit}
          multiple={true}
          onChange={(options) => {
            setSlices(options.map((opt) => opt.id))
          }}
          options={sliceOptions}
          placeholder={t('entities', 'slices')}
          selected={selectedSlices}
          sx={{ maxWidth: 300, minWidth: 200 }}
        />
      }
      icon={
        <Box
          sx={{
            alignItems: 'center',
            bgcolor: 'background.default',
            borderRadius: 1,
            display: 'flex',
            height: 48,
            justifyContent: 'center',
            width: 48
          }}
        >
          <Icon fontSize="large" name="Entity" />
        </Box>
      }
      size="large"
      sx={sx}
      title={entity.title[lang]}
    />
  )
})

export default EntityHeader
